import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { GetReportJobQueueByIdOutput } from './GetReportJobQueueByIdOutput';

export class GetReportJobQueueByIdService extends HttpServiceBase {

  handle = (id: number): Promise<Result<GetReportJobQueueByIdOutput> | null> => {
    const promise = this.http.get<Result<GetReportJobQueueByIdOutput>>(`${this.baseUrlSislogApi}/v2/report-job-queue/${id}`);
    return promise;
  }
}